import {
  HIL_LOAN_SLIDER_MARKS,
  LOAN_SLIDER_MARKS,
  MAXIMUM_LOAN_AMOUNT_1_RANGE,
  MAXIMUM_LOAN_AMOUNT_2_RANGE,
  MAXIMUM_LOAN_AMOUNT_RANGE,
  MAXIMUM_STEP_LOAN_AMOUNT,
  MEDIUM_STEP_LOAN_AMOUNT,
  MINIMUM_STEP_LOAN_AMOUNT,
  POS_LOAN_SLIDER_MARKS,
  STEP_1_RANGE,
  STEP_2_RANGE,
  MAX_HIL_LOAN_AMOUNT_LENGTH,
  MAX_POS_LOAN_AMOUNT_LENGTH,
  STEP_3_RANGE,
  MAXIMUM_STEPS,
  START_HIL_RANGE,
  MAX_POS_STEPS,
  START_FULL_RANGE,
} from 'prequalificationV2/pages/PreQualification/steps/LoanInformation/LoanAmount/loanAmount.constants';
import { MINIMUM_LOAN_AMOUNT } from 'prequalificationV2/pages/PreQualification/steps/LoanInformation/loanInformation.constants';
import { LoanAmountType } from 'prequalificationV2/pages/PreQualification/steps/LoanInformation/LoanAmount/loanAmount.enums';

//Function for denormalising a value (returning it to the original range)
export const denormalizeLoanAmountSliderValue = (value: number) => {
  if (value <= STEP_1_RANGE) {
    return MINIMUM_LOAN_AMOUNT + (value / STEP_1_RANGE) * (MAXIMUM_LOAN_AMOUNT_1_RANGE - MINIMUM_LOAN_AMOUNT);
  } else if (value <= STEP_1_RANGE + STEP_2_RANGE) {
    return (
      MAXIMUM_LOAN_AMOUNT_1_RANGE +
      ((value - STEP_2_RANGE) / STEP_2_RANGE) * (MAXIMUM_LOAN_AMOUNT_2_RANGE - MAXIMUM_LOAN_AMOUNT_1_RANGE)
    );
  } else {
    return (
      MAXIMUM_LOAN_AMOUNT_2_RANGE +
      ((value - (STEP_1_RANGE + STEP_2_RANGE)) / STEP_3_RANGE) *
        (MAXIMUM_LOAN_AMOUNT_RANGE - MAXIMUM_LOAN_AMOUNT_2_RANGE)
    );
  }
};

export const roundToStep = (value: number) => {
  if (value <= MAXIMUM_LOAN_AMOUNT_1_RANGE) {
    return Math.round(value / MINIMUM_STEP_LOAN_AMOUNT) * MINIMUM_STEP_LOAN_AMOUNT; // Step $1,000 for $1,000 - $50,000
  } else if (value <= MAXIMUM_LOAN_AMOUNT_2_RANGE) {
    return Math.round(value / MEDIUM_STEP_LOAN_AMOUNT) * MEDIUM_STEP_LOAN_AMOUNT; // Step $2,000 for $50,000 - $150,000
  } else {
    return Math.round(value / MAXIMUM_STEP_LOAN_AMOUNT) * MAXIMUM_STEP_LOAN_AMOUNT; // Step $10,000 for $150,000 - $500,000
  }
};

// Function for normalising a value (bringing it to the range 0-100)
export const normalizeValue = (value: number) => {
  if (value <= MAXIMUM_LOAN_AMOUNT_1_RANGE) {
    return ((value - MINIMUM_LOAN_AMOUNT) / (MAXIMUM_LOAN_AMOUNT_1_RANGE - MINIMUM_LOAN_AMOUNT)) * STEP_1_RANGE;
  } else if (value <= MAXIMUM_LOAN_AMOUNT_2_RANGE) {
    return (
      STEP_1_RANGE +
      ((value - MAXIMUM_LOAN_AMOUNT_1_RANGE) / (MAXIMUM_LOAN_AMOUNT_2_RANGE - MAXIMUM_LOAN_AMOUNT_1_RANGE)) *
        STEP_2_RANGE
    );
  } else {
    return (
      STEP_1_RANGE +
      STEP_2_RANGE +
      ((value - MAXIMUM_LOAN_AMOUNT_2_RANGE) / (MAXIMUM_LOAN_AMOUNT_RANGE - MAXIMUM_LOAN_AMOUNT_2_RANGE)) * STEP_3_RANGE
    );
  }
};

export const getSliderMarks = (type: LoanAmountType) => {
  switch (type) {
    case LoanAmountType.Full:
      return LOAN_SLIDER_MARKS;
    case LoanAmountType.PointOfSale:
      return POS_LOAN_SLIDER_MARKS;
    case LoanAmountType.HomeImprovement:
      return HIL_LOAN_SLIDER_MARKS;
  }
};

export const getMaxLoanAmountLength = (type: LoanAmountType) => {
  if (type === LoanAmountType.PointOfSale) {
    return MAX_POS_LOAN_AMOUNT_LENGTH;
  }

  return MAX_HIL_LOAN_AMOUNT_LENGTH;
};

export const getMaxSteps = (type: LoanAmountType) => {
  switch (type) {
    case LoanAmountType.Full:
    case LoanAmountType.HomeImprovement:
      return MAXIMUM_STEPS;
    case LoanAmountType.PointOfSale:
      return MAX_POS_STEPS;
  }
};

export const getMinSteps = (type: LoanAmountType) => {
  switch (type) {
    case LoanAmountType.Full:
    case LoanAmountType.PointOfSale:
      return START_FULL_RANGE;
    case LoanAmountType.HomeImprovement:
      return START_HIL_RANGE;
  }
};
